const GTM_EVENTS = {
  NAV_DASHBOARD: 'NAV_DASHBOARD',
  NAV_ORGANIZATIONS: 'NAV_ORGANIZATION',
  NAV_ACCOUNTS: 'NAV_ACCOUNTS',
  NAV_COMMUNICATIONS: 'NAV_COMMUNICATIONS',
  NAV_CAMPAIGNS_EMAIL_TEMPLATES: 'NAV_CAMPAIGNS_EMAIL_TEMPLATES',
  NAV_CAMPAIGN_METRICS: 'NAV_CAMPAIGN_METRICS',
  NAV_CAMPAIGN_SUBSCRIPTION_CATEGORIES: 'NAV_CAMPAIGN_SUBSCRIPTION_CATEGORIES',
  NAV_CONTACTS: 'NAV_CONTACTS',
  NAV_PIPELINES: 'NAV_PIPELINES',
  NAV_SEGMENTS: 'NAV_SEGMENTS',
  NAV_PLAYBOOKS: 'NAV_PLAYBOOKS',
  NAV_TASKS: 'NAV_TASKS',
  NAV_COCKPIT: 'NAV_COCKPIT',
  NAV_SCENARIOS: 'NAV_SCENARIOS',
  NAV_SURVEYS: 'NAV_SURVEYS',
  NAV_HEALTH: 'NAV_HEALTH',
  NAV_CURRENCY: 'NAV_CURRENCY',
  NAV_DATA_MANAGEMENT: 'NAV_DATAMANAGEMENT',
  NAV_PIPELINES_BOARD: 'NAV_PIPELINES_BOARD',
  NAV_PIPELINES_LIST: 'NAV_PIPELINES_LIST',
  NAV_ACCOUNTS_LIST: 'NAV_ACCOUNTS_LIST',
  NAV_ACCOUNTS_BOARD: 'NAV_ACCOUNTS_BOARD',
  NAV_ENTITY_UPLOADS: 'NAV_ENTITY_UPLOADS',
  NAV_WEBHOOKS: 'NAV_WEBHOOKS',
  NAV_USER_MANAGEMENT: 'NAV_USER_MANAGEMENT',
  NAV_ACTIVITIES: 'NAV_ACTIVITIES',
  ACTIONS_ORGANIZATION_CREATED: 'ACTIONS_ORGANIZATION_CREATED',
  ACTIONS_ORGANIZATION_ARCHIVED: 'ACTIONS_ORGANIZATION_ARCHIVED',
  ACTIONS_ORGANIZATION_UNARCHIVED: 'ACTIONS_ORGANIZATION_UNARCHIVED',
  ACTIONS_ORGANIZATION_UPDATED: 'ACTIONS_ORGNIZATION_UPDATED',
  ACTIONS_ORGANIZATION_CHURN: 'ACTIONS_ORGANIZATION_CHURN',
  ACTIONS_CONTACT_CREATED: 'ACTIONS_CONTACT_CREATED',
  ACTIONS_CONTACT_UPDATED: 'ACTIONS_CONTACT_UPDATED',
  ACTIONS_CONTACT_ARCHIVED: 'ACTIONS_CONTACT_ARCHIVED',
  ACTIONS_CONTACT_UNARCHIVED: 'ACTIONS_CONTACT_UNARCHIVED',
  ACTIONS_ACCOUNT_CREATED: 'ACTIONS_ACCOUNT_CREATED',
  ACTIONS_ACCOUNT_UPDATED: 'ACTIONS_ACCOUNT_UPDATED',
  ACTIONS_ACCOUNT_ARCHIVED: 'ACTIONS_ACCOUNT_ARCHIVED',
  ACTIONS_ACCOUNT_CHURN: 'ACTIONS_ACCOUNT_CHURN',
  ACTIONS_ACCOUNT_UNARCHIVED: 'ACTIONS_ACCOUNT_UNARCHIVE',
  ACTIONS_ACCOUNT_MOVED: 'ACTIONS_ACCOUNT_MOVED',
  ACTIONS_PIPELINE_CREATED: 'ACTIONS_PIPELINE_CREATED',
  ACTIONS_PIPELINE_UPDATED: 'ACTIONS_PIPELINE_UPDATED',
  ACTIONS_PIPELINE_ARCHIVED: 'ACTIONS_PIPELINE_ARCHIVED',
  ACTIONS_PIPELINE_UNARCHIVED: 'ACTIONS_PIPELINE_UNARCHIVED',
  ACTIONS_TASKS_UPDATED: 'ACTIONS_TASKS_UPDATED',
  ACTIONS_TASKS_CREATED: 'ACTIONS_TASKS_CREATED',
  ACTIONS_TASKS_COMPLETED: 'ACTIONS_TASKS_COMPLETED',
  ACTIONS_SCENARIOS_UPDATED: 'ACTIONS_SCENARIOS_UPDATED',
  ACTIONS_SCENARIOS_CREATED: 'ACTIONS_SCENARIOS_CREATED',
  ACTIONS_SCENARIOS_DELETED: 'ACTIONS_SCENARIOS_DELETED',
  ACTIONS_360_EMAIL: 'ACTIONS_360_EMAIL',
  ACTIONS_360_ATTRIBUTES: 'ACTIONS_360_ATTRIBUTES',
  ACTIONS_360_ACTIVITIES: 'ACTIONS_360_ACTIVITIES',
  ACTIONS_360_TASKS: 'ACTIONS_360_TASKS',
  ACTIONS_360_NOTES: 'ACTIONS_360_NOTES',
  ACTIONS_360_PULSE: 'ACTIONS_360_PULSE',
  ACTIONS_360_FILE_UPLOAD: 'ACTIONS_360_FILE_UPLOAD',
  ACTIONS_ENTITY_UPLOAD: 'ACTIONS_ENTITY_UPLOAD',
  ACTIONS_ENTITY_EXPORT: 'ACTIONS_ENTITY_EXPORT',
  ACTIONS_FETCH_ACTION_ITEMS: 'ACTIONS_FETCH_ACTION_ITEMS',
  ACTIONS_CREATE_TASK_ACTION_ITEMS: 'ACTIONS_CREATE_TASK_ACTION_ITEMS',
  ACTIONS_AI_CHAT: 'ACTIONS_AI_CHAT',
  ACTIONS_CREATE_SUBSCRIPTION_CATEGORY: 'ACTIONS_CREATE_SUBSCRIPTION_CATEGORY',
  ACTIONS_EDIT_SUBSCRIPTION_CATEGORY: 'ACTIONS_EDIT_SUBSCRIPTION_CATEGORY',
  ACTIONS_CREATE_EMAIL_TEMPLATES: 'ACTIONS_CREATE_EMAIL_TEMPLATES',
  ACTIONS_SAVE_EMAIL_TEMPLATES: 'ACTIONS_SAVE_EMAIL_TEMPLATES',
  ACTIONS_INVITE_USERS: 'ACTIONS_INVITE_USERS',
  ACTIONS_CREATE_ATTRIBUTE: 'ACTIONS_CREATE_ATTRIBUTE',
  ACTIONS_EDIT_ATTRIBUTE: 'ACTIONS_EDIT_ATTRIBUTE',
  ACTIONS_CHANGE_HEALTH_SCOPE: 'ACTIONS_CHANGE_HEALTH_SCOPE',
  ACTIONS_INTEGRATION_CONNECT_OUTLOOK_CALENDAR:
    'ACTIONS_INTEGRATION_CONNECT_OUTLOOK_CALENDAR',
  ACTIONS_INTEGRATION_DISCONNECT_OUTLOOK_CALENDAR:
    'ACTIONS_INTEGRATION_DISCONNECT_OUTLOOK_CALENDAR',
  ACTIONS_INTEGRATION_CONNECT_GMAIL: 'ACTIONS_INTEGRATION_CONNECT_GMAIL',
  ACTIONS_INTEGRATION_DISCONNECT_GMAIL: 'ACTIONS_INTEGRATION_DISCONNECT_GMAIL',
  ACTIONS_INTEGRATION_CONNECT_OUTLOOK: 'ACTIONS_INTEGRATION_CONNECT_OUTLOOK',
  ACTIONS_INTEGRATION_DISCONNECT_OUTLOOK:
    'ACTIONS_INTEGRATION_DISCONNECT_OUTLOOK',
  ACTIONS_INTEGRATION_CONNECT_HUBSPOT: 'ACTIONS_INTEGRATION_CONNECT_HUBSPOT',
  ACTIONS_INTEGRATION_DISCONNECT_HUBSPOT:
    'ACTIONS_INTEGRATION_DISCONNECT_HUBSPOT',
  ACTIONS_INTEGRATION_CONNECT_ZENDESK: 'ACTIONS_INTEGRATION_CONNECT_ZENDESK',
  ACTIONS_INTEGRATION_DISCONNECT_ZENDESK:
    'ACTIONS_INTEGRATION_DISCONNECT_ZENDESK',
  ACTIONS_INTEGRATION_CONNECT_INTERCOM: 'ACTIONS_INTEGRATION_CONNECT_INTERCOM',
  ACTIONS_INTEGRATION_DISCONNECT_INTERCOM:
    'ACTIONS_INTEGRATION_DISCONNECT_INTERCOM',
  ACTIONS_INTEGRATION_CONNECT_SLACK: 'ACTIONS_INTEGRATION_CONNECT_SLACK',
  ACTIONS_INTEGRATION_DISCONNECT_SLACK: 'ACTIONS_INTEGRATION_DISCONNECT_SLACK',
  ACTIONS_INTEGRATION_CONNECT_GOOGLE_CALENDAR:
    'ACTIONS_INTEGRATION_CONNECT_GOOGLE_CALENDAR',
  ACTIONS_INTEGRATION_DISCONNECT_GOOGLE_CALENDAR:
    'ACTIONS_INTEGRATION_DISCONNECT_GOOGLE_CALENDAR',
  ACTIONS_MANAGE_EXCHANGE_RATE: 'ACTIONS_MANAGE_EXCHANGE_RATE',
  ACTIONS_ADD_CURRENCY: 'ACTIONS_ADD_CURRENCY',
};

module.exports = { GTM_EVENTS };
